import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WishlistContext = createContext(null);

export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const { token, isAuthenticated } = useAuth();
  const [wishlist, setWishlist] = useState({ items: [] });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      fetchWishlist();
    } else {
      setWishlist({ items: [] });
    }
  }, [isAuthenticated, token]);

  const fetchWishlist = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(`${API}/wishlist`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setWishlist(response.data);
    } catch (error) {
      console.error("Wishlist fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const addToWishlist = async (productId) => {
    if (!token) return false;
    try {
      await axios.post(
        `${API}/wishlist/add/${productId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      await fetchWishlist();
      return true;
    } catch (error) {
      console.error("Add to wishlist error:", error);
      return false;
    }
  };

  const removeFromWishlist = async (productId) => {
    if (!token) return false;
    try {
      await axios.delete(`${API}/wishlist/remove/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await fetchWishlist();
      return true;
    } catch (error) {
      console.error("Remove from wishlist error:", error);
      return false;
    }
  };

  const isInWishlist = (productId) => {
    return wishlist.items.some((item) => item.id === productId);
  };

  return (
    <WishlistContext.Provider
      value={{
        wishlist,
        loading,
        addToWishlist,
        removeFromWishlist,
        isInWishlist,
        fetchWishlist,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};
